<button
  immoIconButton
  icon="burger-menu"
  theme="surface-container-lowest"
  (click)="isOpen.set(!isOpen())"
  class="menu-trigger"
></button>

<!-- BACKDROP -->
<div class="overlay-backdrop" [class.is-open]="isOpen()" (click)="isOpen.set(false)"></div>

<!-- NAV DRAWER -->
<nav
  class="overlay-drawer"
  [class.is-open]="isOpen()"
  role="dialog"
  aria-modal="true"
  aria-label="Navigation menu"
  [attr.inert]="isOpen() ? null : ''"
>
  <div class="overlay-header">
    <button
      immoIconButton
      icon="x-simple"
      (click)="isOpen.set(false)"
      aria-label="Close navigation"
    ></button>
  </div>

  <hr class="overlay-divider" />

  <div class="overlay-content">
    <immo-navigation [navigation]="navigation()" [isExpanded]="true" />
  </div>

  <hr class="overlay-divider" />

  <div class="overlay-footer">
    <immo-theme-picker theme="surface-container" />
    <immo-language-picker theme="surface-container" />
  </div>
</nav>
